import * as React from "react";
import Navigation, { INavigationProps } from "~/components/navigation/navigation";

export interface INavigationViewProps {
    contextModel: INavigationProps;
}

class NavigationView extends React.Component<INavigationViewProps> {
    public render() {
        return <Navigation {...this.props.contextModel} />;
    }
}

export default NavigationView;
